import {
  FavoriteClientRow,
  FavoriteCompanyRow,
} from 'src/types/favorite';
import {
  ShareCopyCompanyNode,
  ShareCopyUserNode,
} from 'src/types/view_shopping_lists/ShareCopyList';

export const mapFavoriteCompaniesToTree = (
  rows: FavoriteCompanyRow[]
): ShareCopyCompanyNode[] => {
  const nodesById = new Map<number, ShareCopyCompanyNode>();

  rows.forEach((row) => {
    nodesById.set(row.companyId, {
      companyId: row.companyId,
      companyName: row.companyName,
      parentCompanyId: row.parent,
      treeLevel: row.level,
      hasChildren: !row.isLeaf,
      isDeleted: false,
      children: [],
    });
  });

  const roots: ShareCopyCompanyNode[] = [];

  nodesById.forEach((node) => {
    if (node.parentCompanyId == null) {
      roots.push(node);
      return;
    }

    const parent = nodesById.get(node.parentCompanyId);
    if (parent) {
      parent.children.push(node);
      parent.hasChildren = true;
      return;
    }

    roots.push(node);
  });

  return roots;
};

export const mapFavoriteClientsToTree = (
  rows: FavoriteClientRow[],
  lockedUserIds: ReadonlySet<number> = new Set()
): ShareCopyUserNode[] => {
  const nodesById = new Map<number, ShareCopyUserNode>();

  rows.forEach((row) => {
    const isLocked = lockedUserIds.has(row.userId);
    nodesById.set(row.userId, {
      clientId: row.userId,
      contact: row.contactName || '',
      parentId: row.parent === 0 ? null : row.parent,
      treeLevel: row.level,
      lastSharedDate: row.lastSharedDate ?? null,
      lastCopiedDate: row.lastCopiedDate ?? null,
      isDeleted: false,
      hasChildren: !row.isLeaf,
      isPreSelected: isLocked ? false : row.enabled,
      isSelectionLocked: isLocked,
      children: [],
    });
  });

  const roots: ShareCopyUserNode[] = [];

  nodesById.forEach((node) => {
    if (node.parentId == null) {
      roots.push(node);
      return;
    }

    const parent = nodesById.get(node.parentId);
    if (parent) {
      parent.children.push(node);
      parent.hasChildren = true;
      return;
    }

    roots.push(node);
  });

  return roots;
};

export const computeShareRecipientDiff = (
  initialSelectedUserIds: number[],
  selectedUserIds: number[]
): { folderAddUsers: number[]; folderRemoveUsers: number[] } => {
  const initialSet = new Set(initialSelectedUserIds);
  const selectedSet = new Set(selectedUserIds);

  const folderAddUsers = selectedUserIds.filter((id) => !initialSet.has(id));
  const folderRemoveUsers = initialSelectedUserIds.filter((id) => !selectedSet.has(id));

  return { folderAddUsers, folderRemoveUsers };
};
